import { Box, Flex, Link, Loading, Typography } from '@iheartjane/reefer';

import type { SearchSuggestionProductCardProps } from './searchSuggestionProductCard';
import { SearchSuggestionProductCard } from './searchSuggestionProductCard';
import styles from './searchSuggestions.module.css';

export interface SearchSuggestionProduct extends Omit<
  SearchSuggestionProductCardProps,
  'query'
> {
  productId: number;
}

export interface SearchSuggestionsListProps {
  isLoading?: boolean;
  onSearchLinkClick?: () => void;
  products: SearchSuggestionProduct[];
  query: string;
  searchUrl: string;
  totalProducts?: number;
}

export function SearchSuggestionsList({
  isLoading,
  onSearchLinkClick,
  products,
  query,
  searchUrl,
  totalProducts,
}: SearchSuggestionsListProps) {
  return (
    <Box>
      {!!query && (
        <Link
          className={styles['searchLink']}
          variant="minimal"
          to={searchUrl}
          onClick={onSearchLinkClick}
        >
          <Typography>
            Search products for "<mark className={styles['mark']}>{query}</mark>
            "{totalProducts !== undefined && ` (${totalProducts})`}
          </Typography>
        </Link>
      )}

      {products.map(({ productId, ...cardProps }) => (
        <SearchSuggestionProductCard
          key={productId}
          query={query}
          {...cardProps}
        />
      ))}

      {isLoading && (
        <Flex justifyContent="center" className={styles['loading']}>
          <Loading color="black" />
        </Flex>
      )}
    </Box>
  );
}
